import { render, staticRenderFns } from "./RelevantProductsTab.vue?vue&type=template&id=1eed53ef&"
import script from "./RelevantProductsTab.vue?vue&type=script&lang=js&"
export * from "./RelevantProductsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports